<section class="titleS">
    <h1>plante_diverse</h1>
</section>

<!-- Palmatum Atropurpureum" -->

<section class="sec">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/plante_diverse/artar.jpg" class="img-fluid" alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Acer(Artar)</h1>
                                <p>Palmatum Atropurpureum</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Artarul Japonez Rosu este un copac cu o coroana deosebit de atractiva. Prin frunzele sale in
                            nuante de rosu. In perioada anotimpului de toamna frunzele primesc o nuanta intensa de
                            rosu-ruginiu. Frunzele au forma palmata si o lungime de 4-10 centimetri.</p>
                        <p>Solul preferat de Artarul Atropurpureum este cel umed, bine drenat, solul acid si alcalin.
                            Artarul japonez este o planta foarte rezistenta la daunatori si la poluare. Este un copac
                            decorativ datorita culorii atractive a frunzelor care se schimba de la anotimp
                            la anotimp. Artarul Japonez Atropurpureum este un copac perfect pentru decorarea gradinilor
                            si a parcurilor. Frumusetea lui aparte in combinatie cu alti arbori va iesi in evidenta.</p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Acer(Artar)</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Palmatum Atropurpureum</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>160-180</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>300-400</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>500</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>All Season</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Semiumbra, umbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>
<hr>

<!-- Shirasawanum "Aureum" -->
<section class="sec">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/plante_diverse/acershirasawanumAureum.jpg" class="img-fluid" alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Acer (Artar)</h1>
                                <p>Shirasawanum "Aureum"</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Acer shirasawanum Aureum este un arbust cu frunzisul cazator care face parte din familia
                            Sapindaceae. Soiul este originar din Japonia si creste dens cu frunzisul decorativ. Primeste
                            forme ciudate, interesante. Frunzele cresc sub forma palmat-compusa formate din 9-13 lobi.
                            Frunzele in anotimpul de primavara sunt in nuante de verde-auriu, in anotimpul de toamna ele
                            devin galben-portocalii, rosii.</p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Acer (Artar)</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Shirasawanum "Aureum"</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>50-70</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>200</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>150</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>All Season</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>
<hr>

<!-- Carex bronze -->
<section class="sec">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">

                        <img src="/assets/pics/plante_diverse/carexbronze.jpg" class="img-fluid" alt="tuja">

                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Iarba</h1>
                                <p>Carex bronze</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>O planta decorativa, ce formeaza tufe bogate, cu frunze viu colorate intr-o nuanta uimitoare
                            de portocaliu. Se potriveste perfect in decorul oricarui peisaj. Completeaza armonios
                            bordurile si stancariile, creand o imagine exotica.</p>


                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Iarba</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Carex bronze</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>50-70</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>80-100</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>25</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>
<hr>


<!-- Hakuro Nishiki -->
<section class="sec">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/plante_diverse/salixintegrahakuronishikitufa.jpg" class="img-fluid" alt="tuja">

                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Salix integra (Salcie)</h1>
                                <p>Hakuro Nishiki</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Salcia japoneză sau salcia colorată este un arbust decorativ prin frunzele sale colorate în nuanţe de roz, crem, verde.
                           De asemenea, florile sunt colorate într-un spectru vast de la maroniu la roșu. Este o plantă dioică, cu flori masculine și feminine, pe plante separate. 
                           Frunzele sunt aranjate în perechi opuse sau verticale. Salcia japoneză face și fruct, dar nesemnificativ din punct de vedere decorativ.
                           Preferă expunerea în plin soare sau semiumbră, plantat în sol fertil, umed și bine drenat, dar rezistă și în soluri uscate, nisipoase.
                           Rezistă bine la dăunători și temperaturi scăzute din timpul iernii. Comandă salcia japoneză şi ea va deveni un element extrem de atractiv în grădina ta!</p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Salix integra (Salcie)</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Hakuro Nishiki</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>50</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>250</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>40</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>All Season</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>
<hr>

<!-- Salix americana -->
<section class="sec">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/plante_diverse/Salix americana.jpg" class="img-fluid" alt="tuja">

                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Salix (Salcie)</h1>
                                <p>Americana</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Arborii de salcie pot fi drepți, rotunjiți, plângători sau pitici. 
                           Culoarea scoarței variază, în funcție de soi, iar frunzele sunt de obicei verde salvie în vârf și mai palide pe partea inferioară, ascuțite la fiecare capăt și cresc alternativ de-a lungul crenguțelor.
                           La începutul primăverii, ei poartă flori mici și amoni. „Americana” este un arbust mediu cu o nouă creștere galbenă/verde, care se maturizează până la un roșu-brun.</p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Salix (Salcie)</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Americana</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>200</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>300</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>250</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>All Season</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>
<hr>

<!-- Mount Aso -->
<section class="sec">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/plante_diverse/salixmountaso.jpg" class="img-fluid" alt="tuja">

                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Salix (Salcie)</h1>
                                <p>Mount Aso</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Salix gracilistyla 'Mount Aso' este un arbust decorativ prin "flori"(mărțișori), formă și frunze.
                           Mărțișorii de culoare roz viu, apar dealungul crengilor în timpul iernii. Frunzele au o nuanță de verde-argintiu.
                           Este un arbust de talie mică, este iubitoare de lumină. Este rezistent la secetă, ger, poluare și dăunători. Nu are pretenții față de sol.
                           Este recomandat tăierea de intreținere, pentru formarea coroanei. Perioada de tăiere este imediat după trecerea mărțișorulor.
                           Se poate planta solitar, în stâncari, în vase decorative dar si ca gard viu este atractiv.</p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Salix (Salcie)</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Mount Aso</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>150</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>200</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>150</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>All Season</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>
<hr>

<!-- Purpurea Nana -->
<section class="sec">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/plante_diverse/salixpurpureanana.jpg" class="img-fluid" alt="tuja">

                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Salix (Salcie)</h1>
                                <p>Purpurea Nana</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Salix purpurea este o specie arboricola cu aspect arbustiv, tufa relativ sferica ce nu depaseste diametru de 1-1,5m .
                           Lastarii tineri sunt roscati dar devin gri deschis pana la maro-cenusiu pe masura ce imbatranesc. Tocmai de aceea se impune taiarea anuala a tufei astfel incat sa ne putem bucura in fiecare an de aspectul placut al lastarilor tineri roscati.
                           Aceasta salcie pitica este interesanta si prin frunzele mici, inguste, liniare, albastre-verzui pe partea dorsala, verde pal pe partea ventrala, zimtate pe jumatatea dinspre varf.
                           Florile sunt matisori mici cu inflorescente rosii ce apar primavara devreme inaintea infrunzirii. Pe masura ce se consuma, inflorescentele devin albe apoi elibereaza semintele mici.
                           Salciile decorative sunt arbusti foarte usor de intretinut, vegeteaza bine pe terenurile mai umede dar suporta fara probleme orice tip de sol fara a avea nevoie de irigatii. Cateva minute pe an pentru a taia tufa sunt suficiente pentru a avea o salcie purpurie frumoasa in gradina.</p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Salix (Salcie)</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Purpurea Nana</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>50</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>100-150</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>40</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>All Season</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>
<hr>

<!-- Hakuro Nishiki -->
<section class="sec">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/plante_diverse/salcie.jpg" class="img-fluid" alt="tuja">

                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Salix integra (Salcie)</h1>
                                <p>Hakuro Nishiki</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Salcie Japoneza altoita pe trunchi (Salix integra "Hakuro Nishiki") - este un arbust
                            decorativ ce poarta si denumirea de salcie japoneza, cu lastarii noi de culoare roz si un
                            frunzis pestrit (verde cu crem), aceasta specie de salcie altoita devine foarte usor un
                            punct de atractie al gradinii.</p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Salix integra (Salcie)</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Hakuro Nishiki</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>incepand cu 120</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>170-180</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu 150</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>All Season</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>
<hr>

<!-- Kilmarnock -->
<section class="sec">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/plante_diverse/salixcaprea.jpg" class="img-fluid" alt="tuja">

                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Salix Caprea</h1>
                                <p>Kilmarnock</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Salcia plangatoare este cu siguranta unul din elementele decorative din gradina noastra ce
                            atrage toata atentia privitorilor. Salcia plangatoare ofera nu numai eleganta si distinctie
                            spatiului in care este plantata dar, este si nemaipomenita in crearea pe timpul verii a unui
                            spatiu umbros si racoros.Salcia plangatoare este un arbore care creste foarte repede, ajunge
                            si la 20 de metri inaltime, dar are o durata de viata relativ scurta, de aproximativ 30 de
                            ani. Salciile noastre au fost dintre primele plante la noi in gradina, au crescut
                            spectaculos practic dintr-o simpla creanga infipta in pamant. Acum ne ofera intimitate si
                            totodata o bariera fonica pentru zgomotului de la drum.Salcia plangatoare infloreste
                            primavara sub forma unor matisori verzi care apoi se vor acoperi de un puf alb. Pentru a fi
                            deranjati de acest puf, ramurile salciei pot fi udate cu apa iar puful va cadea mai repede.
                            Locul ideal de plantare este unul insorit, de preferat langa apa. Radacinile foarte
                            puternice se intind pe o suprafata chiar si de trei ori mai mare decat diametrul coroanei
                            asa ca asigurati-va ca nu plantati salcia plangatoare langa conducte de apa sau fundatii de
                            beton pentru ca vor fi in pericol de distrugere. Taierile de intretinere se executa toamna
                            inainte de inghet sau primavara dupa inghet. In primul an se vor taia ramurile mai mici care
                            cresc spre sol precum si ramurile din partea de jos pentru a permite dezvoltarea unui
                            trunchi mai puternic. Dupa anul trei, mentinerea salciei plangatoare va fi minima:

                            - se vor taia in primul rand varfurile ramurile care ating solul
                            - apoi ramurile care se incruciseaza sau care stau unele peste altele deoarece presiunea
                            poate provoca daune copacului, lemnul de salcie fiind destul de fragil.
                            - in final, se vor taia ramurile care cresc in sus pentru a nu strica forma salciei
                            plangatoare.
                            In primul an, udati salcia regulat mai ales atunci cand pamantul de la suprafata devine
                            uscat, apoi din al doilea an udati-o doar pe timp de seceta.
                            Important in primul an de la plantare este si eliminarea buruienilor de langa salcie, dar nu
                            cu ajutorul pesticidelor./p>

                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Salix integra (Salcie)</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">salix Caprea</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>120</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>170-180</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>150</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>All Season</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>Soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>
<hr>

<!-- Larice decidua -->
<section class="sec">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/plante_diverse/larixdecidua.jpg" class="img-fluid" alt="tuja">

                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Larice</h1>
                                <p>Larice decidua</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Laricele este singurul conifer cu frunze cazatoare si se altoieste pe trunchi inalt
                            pentru un efect deosebit. Ramurile poarta fascicole de ace lungi de 1-3 cm, liniare, colorate in verde
                            deschis care toamna inainte de cadere devin galbene. Este rezistent la seceta si se poate
                            planta in plin soare. Suporta tunderea ramurilor la nivelul dorit. Nu necesita ingrijiri speciale: udare moderata, iar primavara si toamna, pamantul
                            se sapa in jurul copacului. Primavara se administreaza fertilizante.</p>


                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Larice</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Larice decidua</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>200cm</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>1500</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>200</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>All season</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>
<hr>

<!-- Cedrus Karl Fuchs -->
<section class="sec">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/plante_diverse/cedru-himalayan-karl-fuchs-cedrus-deodara-karl-fuchs.jpg" class="img-fluid" alt="tuja">

                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Cedrus</h1>
                                <p>Cedrus karl fuchs</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Cedrus deodara Karl Fuchs este un cedru himalayan deosebit, un soi foarte rezistent, cu două caracteristici principale. Acele tinere sunt albastru argintiu, spre deosebire de majoritatea cedrilor, care au acele verzi; are o creștere mult mai îngustă, ceea ce îl face potrivit și pentru grădini de mai mici dimensiuni. 
                            Ramurile sunt stratificate, orientate spre lateral, paralele cu pământul și vârfurile ușor arcuite spre pământ. 
                            Preferă locurile însorite, tolerează majoritatea tipurilor de sol cu condiția să fie bine drenate.
                             Deși cedrii în general sunt mai sensibili la frig, Karl Fuchs poate supraviețui și în locuri mai puțin prielnice și rezistă la temperaturi de până la -27 grade Celsius. </p>


                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Cedrus</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Cedrus Karl Fuchs</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>120-140cm</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>600-800</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>250</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>All season</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>
<hr>

<!-- Cedrus Glauca Atlantica -->
<section class="sec">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/plante_diverse/CedrusGlaucaAtlantica.jpg" class="img-fluid" alt="tuja">

                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Cedrus</h1>
                                <p>Cedrus glauca Atlantica</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Arbore rasinos de gradina, evergreen, Cedrus atlantica glauca (cedru argintiu). 
                            Conifer de talie mare, cu port piramidal larg, cu varful tulpinii curbat, ceea ce creeaza un efect impozant.
                            Acele sunt persistente de culoare gri verde albastrui. Conurile sunt numeroase de 6-10 cm lungime la maturitate, de culoare maro. 
                            Se remarca prin culoarea gri albastrui a frunzelor, fiind un conifer impunator, poate fi plantat solitar pentru a-i fi pusa in evidenta frumusetea. 
                            Are un ritm lent de crestere. Se dezvolta bine in plin soare. Se adapteaza pe toate tipurile de sol si se uda moderat. </p>


                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Cedrus</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Cedrus Glauca Atlantica</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>100-120cm</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>2000</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>400</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>All season</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>
<hr>

<!-- Laurocerasus Novita -->
<section class="sec">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/plante_diverse/prunuscaucasica.jpg" class="img-fluid" alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Prunus</h1>
                                <p>Laurocerasus Caucasica</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Arbust ornamental vesnic verde condus ca si copac pe un trunchi de 90-100 cm, cu coroana
                            compacta si densa. Frunzele ovale sunt de culoare verde stralucitor. Se preteaza foarte bine
                            la tuns.</p>




                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Prunus</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Laurocerasus Caucasica</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>incepand cu: 120</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>300-400</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu: 150</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>
<hr>

<!-- Laurocerasus Genolia -->
<section class="sec">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/plante_diverse/prunusgenolia.jpg" class="img-fluid" alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Prunus</h1>
                                <p>Laurocerasus Genolia</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Arbust ornamental vesnic verde condus ca si copac pe un trunchi de 90-100 cm, cu coroana
                            compacta si densa. Frunzele ovale sunt de culoare verde stralucitor. Se preteaza foarte bine
                            la tuns.</p>




                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Prunus</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Laurocerasus Genolia</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>incepand cu: 70</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>300-400</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu: 50</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>
<hr>

<!-- 	Laurocerasus Etna -->

<section class="sec">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/plante_diverse/prunusetna.jpg" class="img-fluid" alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Prunus</h1>
                                <p>Laurocerasus Etna</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Are crestere rapida si se remarca prin aspectul frunzisului de culoare verde-crud, frunzele
                            noi iesite sunt de culoarea bronzului, precum si prin inflorescentele albe, in forma de
                            ciorchini, puternic parfumate. Rezista pana la -27 grade Celsius. Se foloseste la garduri
                            vii de pana la 200 cm inaltime si 80 cm latime. Recomandam plantarea la aproximativ 40-50 cm
                            unul fata de altul.</p>



                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Prunus</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Laurocerasus Etna</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>50-60, 90-110</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>200-300</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>incepand cu 60</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>
<!-- 	Fastigiata -->
<hr>
<section class="sec">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/plante_diverse/tisataxusbacata.jpg" class="img-fluid" alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Taxus Baccata</h1>
                                <p>Fastigiata</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Una dintre cele mai populare conifere din lume, Taxus baccata "Fastigiata" este un arbust
                            dens, vesnic verde.</p>
                        <p>Ramurile sale rigid inaltate se mandresc cu ace lungi, dispuse radial, de culoare verde
                            inchis.</p>
                        <p>Acest soi feminin produce conuri vizibile, rosii de coral, care contrasteaza frumos cu
                            frunzisul. Poate fi usor taiata si modelata.</p>




                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Taxus Baccata</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Fastigiata</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>incepand cu 50</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>300-500</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>50</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare,semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>

<hr>

<!-- 	Sempervirens Elegantissima -->
<section class="sec">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/plante_diverse/buxusbicolor.jpg" class="img-fluid" alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Buxus</h1>
                                <p>Sempervirens Elegantissima</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>"Elegantissima" este un arbust vesnic verde de dimensiuni medii, cu frunzis dens si compact
                            rotunjit. Frunze înguste ovale sau alungite, cu margini înguste de culoare alb-crem,
                            uneori distorsionate. </p>




                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Buxus</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Sempervirens Elegantissima</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>40</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>100-150</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>40</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>
<hr>
<!-- 	Cimisir -->
<section class="sec" id="ultim">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/plante_diverse/buxuscimisir.jpg" class="img-fluid" alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Buxus</h1>
                                <p>Cimisir</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Buxus sempervirens prezinta o coroana compacta de culoare verde intens, compusa din frunze
                            mici, stralucitoare, opus ovale, persistente. Se utilizeaza solitar, in grupuri sau in
                            garduri vii. Rezistenta crescuta la ger. Perioada indicata pentru tundere este iulie-august.
                            Se adapteaza oricarui tip de sol: fertil, bogat in humus sau sarac si calcaros. Poate fi
                            expus atat in soare cat si in semiumbra permanenta fiind folosit si ca gard viu si borduri.
                            Se uda des, dar sa nu balteasca apa, solul sa aiba drenaj bun.</p>




                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Buxus</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Cimisir</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>I 30-40 D 30-40</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>200-300</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>75</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>
<hr>

<!-- Prunus Pisardii -->
<section class="sec" id="ultim">
    <div class="row">
        <div class="col-sm-6 col-xs-6 ">


            <div class="wrapper">
                <div class="container">
                    <div class="top">
                        <img src="/assets/pics/plante_diverse/prunus-pissardii.jpg" class="img-fluid" alt="tuja">
                    </div>
                    <div class="bottom">
                        <div class="left">
                            <div class="details">
                                <h1>Prunus</h1>
                                <p>Pisardii</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="inside">
                    <div class="icon"><i class="material-icons">Detalii</i></div>
                    <div class="contents">
                        <p>Prunus cerasifera Nigra este un arbore de talie medie cu frunzele cazatoare din categoria pomilor fructiferi.
                           Fructul este mic, rosu, edibil, apare in August-Septembrie, nu are valoare alimentara. Copacul creste cu tulpina puternica, formeaza o coroana rotunda, decorativa, cu frunzisul dens, culoare rosu-purpuriu.
                           Datorita culorii si multitudinii de flori copacul este de o frumusete aparte, foarte ornamental. Este un element decorativ perfect pentru gradinile de mici dimensiuni.                        Florile sunt de culoare alb-roz, discret parfumate, fructele sunt rosii purpurii. Sunt asadar arbori decorativi atat prin spectacolul floral dar mai ales prin pata de culoare contrastanta pe care o realizeaza frunzisul roscat pe tot parcursul verii.
                           Creste in solul de gradina, chiar si in cel uscat si pietros, dar da cele mai bune rezultate in solurile afanate, aluviale, permeabile.
                           Se recomanda ca plantarea sa se faca in plin soare. Rezista pana la -34 grade Celsius.                            
                           Este foarte rezistent la seceta, ger si poluarea din marile orase.</p>




                        <h5>Imagini cu caracter informativ</h5>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-sm-6 col-xs-6 ">
            <h2 class="text-center titletabel">Prunus</h2>
            <table class="table table-striped  ">
                <thead>
                    <tr>
                        <th scope="col">Nume</th>
                        <th scope="col">Pisardii</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Dimensiune la livrare(cm)</th>
                        <td>180-200</td>
                    </tr>
                    <tr>
                        <th scope="row">Inaltime la maturitate(cm)</th>
                        <td>300-400</td>
                    </tr>
                    <tr>
                        <th scope="row">Pret(lei)</th>
                        <td>120</td>
                    </tr>
                    <tr>
                        <th scope="row">Perioada plantare</th>
                        <td>Martie-Noiembrie</td>
                    </tr>
                    <tr>
                        <th scope="row">Cerinte fata de amplasament</th>
                        <td>soare, semiumbra</td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</section>
<hr>